<div class="ml-3">
  <div class="text-lg">
    Campaign Trackers
</div>


  <div class="mt-6">
    <div class="mb-6">
         <p-calendar 
              [(ngModel)]="date"
              placeholder="Select Date"
              inputId="date"
              dateFormat="mm/dd/yy"
              showIcon="true"
              [showButtonBar]="true"
              (ngModelChange)="getOverviews()"
              />                  
    </div>

    <div class="mb-3 font-semibold">Creditor Campaign Performance Overview</div>
    
    <div *ngIf="!hasTableData" style="text-align:center; margin-top:3rem; color: #336699; font-size: 1rem;">
          🚫 No records found
    </div>
    
    <div class="flex align-items-start gap-2">
      <div 
      *ngIf="hasTableData"
       [pTooltip]="isShowOverview? 'Hide Overview' : 'Show Overview'"
        (click)="toggleOverview()">
        <p-button    
          [icon]="'pi '+(isShowOverview? 'pi-chevron-up' : 'pi-chevron-down')" [outlined]="true" size="small" />
      </div>
      <div>
         <p-table 
            *ngIf="hasTableData"
            [value]="isShowOverview? creditorOverviews : []" 
            [rows]="10"
            [rowsPerPageOptions]="[10, 30, 50]"
            [paginator]="true"
            [tableStyle]="{ 'min-width': '50rem' }"
          >
            <ng-template pTemplate="header">
                    <tr class="text-xs">
                        <th>Creditor Id</th>
                        <th>Creditor Name</th>
                        <th>Recipient Count</th>
                        <th>Total Emails</th>
                        <th>Total Sms</th>
                        <th>Total Vm Drop</th>
                        <th>Total AI</th>
                        <th>Rejected Emails</th>
                        <th>Rejected SMS</th>   
                        <th>Rejected VM</th>                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-overview>
                    <tr class="text-xs">
                          <td>{{ overview.CreditorId }}</td>
                          <td>{{ overview.CreditorName }}</td>
                          <td>{{ overview.RecipientCount }}</td>
                          <td>{{ overview.TotalEmails }}</td>
                          <td>{{ overview.TotalSms }}</td>
                          <td>{{ overview.TotalVmDrop }}</td>
                          <td>{{ overview.TotalAI }}</td>
                          <td>{{ overview.RejectedEmails }}</td>
                          <td>{{ overview.RejectedSMS }}</td>                 
                          <td>{{ overview.RejectedVm }}</td>    
                    </tr>
                </ng-template>
          </p-table>

         
      </div>
    </div>
  </div>

  <div
    *ngIf="hasTableData"
   class="border-top-1 border-300 pt-5 mt-7">
    <div class="mb-3 font-semibold">Creditor Campaign Performance</div>

    <div class="ml-4 mb-3">
        <p-selectButton 
            [options]="toggleOptions" 
            [(ngModel)]="selectedToggle" 
            optionLabel="icon">
             <ng-template  let-item pTemplate>
                <div tooltipPosition="top" [pTooltip]="item.tooltip">
                   <i [class]="item.icon"></i>
                </div>
              </ng-template>
        </p-selectButton>        
    </div>

    <div class="tabs-wrapper-with-arrows">
       <p-button 
      
        class="arrow left" (click)="scrollLeft()" icon='pi pi-chevron-left' [text]="true" size="small" />

      <div #tabsContainer class="tabs-container">
        <div
          class="tab flex align-items-center justify-content-between gap-2"
          *ngFor="let tab of creditorOverviews; let i = index;"
          [class.active]="tab.CreditorId === activeTabId"
          (click)="selectTab(tab.CreditorId, i)"
        >
          <div>
            {{ tab.CreditorName }}
          </div>
          <div>
            {{tab.CreditorId}}
          </div>
        </div>
      </div>

        <p-button  
       
         (click)="scrollRight()" icon='pi pi-chevron-right' [text]="true" size="small" />
    </div>

    <div class="tab-content">
        <div *ngIf="hasTableData">    
          <p-table   
              *ngIf="selectedToggle.isShowDetails"            
              [value]="this.activeCreditorTabPerformanceList" 
              [rows]="10"
              [paginator]="true"
              [rowsPerPageOptions]="[10, 30, 50]"
              [tableStyle]="{ 'min-width': '50rem' }"
            >
              <ng-template pTemplate="header">
                      <tr class="text-xs">
                          <th style="width: 200px;">Automation Tag</th>
                          <th>Campaign Id</th>
                          <th>Schedule Id</th>

                          <th>Name</th>
                          <th>Days from Start</th>
                          <th>Eligible Accounts</th> 
                          
                          <th>Total Emails</th>  
                          <th>Total SMS</th>  
                          <th>Total VM Drop</th>  
                          <th>Total AI</th>  

                          <th>Rejected Emails</th>      
                          <th>Rejected SMS</th>       
                          <th>Rejected VM</th>   
                                           
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                      <tr class="text-xs">
                         <td>
                          <span 
                            class="tag-chip"
                            [ngStyle]="{ 'background-color': tagColors[item.AutomationTag], 'color': 'white', 'padding': '0.2rem 0.5rem', 'border-radius': '12px' }"
                          >
                            {{ item.AutomationTag }}
                          </span>
                        </td>
                          <td>{{ item.CampaignId }}</td>
                          <td>{{ item.ScheduleId }}</td>
                          <td>{{ item.Name }}</td>

                          <td>{{ item.DaysFromStart }}</td>
                          <td>{{ item.EligibleAccounts }}</td>  

                          <td>{{ item.TotalEmails }}</td>               
                          <td>{{ item.TotalSms }}</td>   
                          <td>{{ item.TotalVmDrop }}</td>   
                          <td>{{ item.TotalAI }}</td>   
                          
                          <td>{{ item.RejectedEmails }}</td>  
                          <td>{{ item.RejectedSMS }}</td>   
                          <td>{{ item.RejectedVm }}</td>  
                          
                      </tr>
                  </ng-template>
          </p-table>

          <p-table 
              *ngIf="!selectedToggle.isShowDetails"
              [value]="this.activeCreditorTabPerformanceTotalList" 
              [rows]="10"
              [paginator]="true"
              [rowsPerPageOptions]="[10, 30, 50]"
              [tableStyle]="{ 'min-width': '50rem' }"
            >
              <ng-template pTemplate="header">
                      <tr class="text-xs">
                          <th>Automation Tag</th>
                          <th>Total Eligible Accounts</th>  
                          <th>Total Sms</th>  
                          <th>Total Email</th>  
                          <th>Total VM</th>  
                          <th>Total AI</th>  
                          <th>Rejected Emails</th>      
                          <th>Rejected SMS</th>       
                          <th>Rejected VM</th>     
                          <th>Final Recipient Count</th>                    
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                      <tr class="text-xs">
                         <td>
                          <span 
                            class="tag-chip"
                            [ngStyle]="{ 'background-color': tagColorsTotal[item.AutomationTag], 'color': 'white', 'padding': '0.2rem 0.5rem', 'border-radius': '12px' }"
                          >
                            {{ item.AutomationTag }}
                          </span>
                        </td>
                          <td>{{ item.EligibleAccounts }}</td>   
                          <td>{{ item.TotalSms }}</td>   
                          <td>{{ item.TotalEmail }}</td>  
                          <td>{{ item.TotalVm }}</td>   
                          <td>{{ item.TotalAI }}</td>   
                          <td>{{ item.RejectedEmails }}</td>  
                          <td>{{ item.RejectedSMS }}</td>   
                          <td>{{ item.RejectedVm }}</td>   
                          <td>{{ item.FinalRecipientCount }}</td>               
                      </tr>
                  </ng-template>
          </p-table>

        </div>
    </div>
  </div>

</div>